import { render, staticRenderFns } from "./DialogCopyUrlPagamento.vue?vue&type=template&id=f87c5ef0&scoped=true&"
import script from "./DialogCopyUrlPagamento.vue?vue&type=script&lang=js&"
export * from "./DialogCopyUrlPagamento.vue?vue&type=script&lang=js&"
import style0 from "./DialogCopyUrlPagamento.vue?vue&type=style&index=0&id=f87c5ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87c5ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f87c5ef0')) {
      api.createRecord('f87c5ef0', component.options)
    } else {
      api.reload('f87c5ef0', component.options)
    }
    module.hot.accept("./DialogCopyUrlPagamento.vue?vue&type=template&id=f87c5ef0&scoped=true&", function () {
      api.rerender('f87c5ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogCopyUrlPagamento.vue"
export default component.exports